import { render, staticRenderFns } from "./fluxStatistics.vue?vue&type=template&id=6016335e&scoped=true&"
import script from "./fluxStatistics.vue?vue&type=script&lang=js&"
export * from "./fluxStatistics.vue?vue&type=script&lang=js&"
import style0 from "./fluxStatistics.vue?vue&type=style&index=0&lang=css&"
import style1 from "./fluxStatistics.vue?vue&type=style&index=1&id=6016335e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6016335e",
  null
  
)

export default component.exports